import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        login(res.data);
        // Clear the hash by replacing state, then route based on account status
        window.history.replaceState(null, '', window.location.pathname);
        const status = res.data.account_status;
        if (status === 'pending_profile') {
          navigate('/complete-profile', { replace: true });
        } else if (status === 'pending_parent_approval' || status === 'denied') {
          navigate('/pending-approval', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        const msg = err.response?.data?.detail || err.message || 'Authentication failed';
        console.error('Auth exchange failed:', msg, err);
        setError(msg);
        toast.error(`Sign-in failed: ${msg}`);
        // Give user a moment to see the error before redirecting home
        setTimeout(() => navigate('/', { replace: true }), 4500);
      }
    };

    exchangeSession();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <div className="mono-data text-lg text-[#09090B] mb-2" data-testid="auth-error">Sign-in failed</div>
          <div className="text-sm text-zinc-600">{error}</div>
          <div className="mono-data text-xs text-zinc-400 mt-4">Redirecting…</div>
        </div>
      ) : (
        <div className="mono-data text-lg animate-pulse-red">Authenticating...</div>
      )}
    </div>
  );
}
